'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024$002dCat$00241 from "./samples.-Enum-Sample$package$-Cat$1.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$$anon$17(evaluator$14) {
  this.L4 = null;
  this.L4 = evaluator$14;
}
export { $c_Lsamples_EnumSample$package$$anon$17 as $c_Lsamples_EnumSample$package$$anon$17 };
$p = $c_Lsamples_EnumSample$package$$anon$17.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$$anon$17;
/** @constructor */
function $h_Lsamples_EnumSample$package$$anon$17() {
}
export { $h_Lsamples_EnumSample$package$$anon$17 as $h_Lsamples_EnumSample$package$$anon$17 };
$h_Lsamples_EnumSample$package$$anon$17.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.L4.h();
  return ((v instanceof $j_samples$002e$002dEnum$002dSample$0024package$0024$002dCat$00241.$c_Lsamples_EnumSample$package$Cat$1) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EnumSample$package$$anon$17 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$$anon$17, "samples.EnumSample$package$$anon$17", ({
  oS: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EnumSample$package$$anon$17 as $d_Lsamples_EnumSample$package$$anon$17 };
